import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";

class OpisWyjazduRelacja extends PureComponent<any> {
  render() {
    const { report } = this.props;
    return (
      <a
        className="OpisWyjazduRelacja_link"
        title={report.tittle}
        href={report.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {report.tittle}
      </a>
    );
  }
}

export default OpisWyjazduRelacja;
